module.exports = __webpack_public_path__ + "img/footer-logo-temp.33c141cc.png";